import axios from 'axios';
import InternalChatUser from '@src/types/InternalChatUser';
import InternalMessage from '@src/types/InternalMessage';

interface MessagesResponse {
    data: InternalMessage[];
    meta: { current_page: number; last_page: number };
}

class InternalChatService {
    async getUsers(): Promise<InternalChatUser[]> {
        const response = await axios.get('/api/internal-chat/users');
        return response.data.data ?? [];
    }

    async getMessages(userId: number, page = 1): Promise<MessagesResponse> {
        const response = await axios.get(
            `/api/internal-chat/conversations/${userId}/messages`,
            { params: { page } }
        );
        return response.data;
    }

    async markRead(userId: number): Promise<void> {
        await axios.post(`/api/internal-chat/conversations/${userId}/read`);
    }


    async sendMessage(userId: number, body: string | null, file?: File | null): Promise<InternalMessage> {
        const form = new FormData();
        if (body) form.append('body', body);
        if (file) form.append('attachment', file);

        const response = await axios.post(
            `/api/internal-chat/conversations/${userId}/messages`,
            form,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return response.data.data;
    }
}

export default new InternalChatService();
